import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets window scroll to top on every route change.
 *
 * Without this, React Router preserves scroll position when navigating
 * between routes — so clicking a link from the bottom of one page lands
 * the user in the middle of the next page. We skip the reset when a
 * hash is present (e.g. /#contact) so in-page anchors keep working.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    // Use instant scroll (not smooth) so route changes feel like page loads.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
